import ImageListItem from '../ImageListItem/ImageListItem';
import React, { useState } from 'react';
import ConfirmDialog, { ConfirmContentType } from '../ConfirmDialog/ConfirmDialog';
import { useTranslation } from 'react-i18next';

interface ImagePreviewProps {
    data?: Array<string>;
    onDelete?: (index: number) => void;
    disabled?: boolean;
}

const ImagePreview = ({ data, onDelete, disabled }: ImagePreviewProps) => {
    const { t } = useTranslation();
    const [pendingDeleteIndex, setPendingDeleteIndex] = useState<number | null>(null);

    if (!data?.length) {
        return null;
    }

    return (
        <>
            <div role={'list'} aria-label={'Ablesefotos'}>
                {data.map((image, index) => {
                    return (
                        <div role={'listitem'} key={`image-${index}`}>
                            <ImageListItem
                                image={image}
                                onDelete={onDelete ? () => setPendingDeleteIndex(index) : undefined}
                                disabled={disabled}
                            />
                        </div>
                    );
                })}
            </div>
            {onDelete && (
                <ConfirmDialog
                    open={pendingDeleteIndex !== null}
                    type={ConfirmContentType.WARNING}
                    showIcon={true}
                    title={t('jobs.details.confirmRemoveImage.title')}
                    content={t('jobs.details.confirmRemoveImage.content')}
                    okText={t('jobs.details.confirmRemoveImage.ok')}
                    cancelText={t('common.dialog.abort')}
                    onOk={() => {
                        if (pendingDeleteIndex !== null) {
                            onDelete(pendingDeleteIndex);
                        }
                        setPendingDeleteIndex(null);
                    }}
                    onCancel={() => setPendingDeleteIndex(null)}
                />
            )}
        </>
    );
};

export default ImagePreview;
